// internal deps
import { PayLaterLinkedData } from "@swiggy-private/payment-ui";

// utils
import { unwrapResponse, makeApiCall } from "@payment-client/utils/Api";

// interfaces
import { ApiResponse } from "@payment-client/interfaces/Api";

const ENDPOINT = {
    CHECK_PAYLATER_LINK_STATUS: "/api/v1/check-paylater-link-status",
    LINK_PAYLATER: "/api/v1/link-paylater",
    VALIDATE_PAYLATER_OTP: "/api/v1/validate-paylater-otp",
    RESEND_PAYLATER_OTP: "/api/v1/resend-paylater-otp",
};

export async function linkPayLater(apiHost: string, payLaterCode: string, mobileNumber: string): Promise<object> {
    const response = unwrapResponse(
        await makeApiCall<object>({
            apiHost,
            endpoint: ENDPOINT.LINK_PAYLATER,
            searchParams: { payLaterCode },
            bodyParams: { mobileNumber },
            options: {
                method: "POST",
            },
        }),
    );

    return response.toPromise();
}

export async function validatePayLaterOtp(
    apiHost: string,
    params: { payLaterCode: string; otp: string; state: object },
): Promise<ApiResponse<object>> {
    return makeApiCall<object>({
        apiHost,
        endpoint: ENDPOINT.VALIDATE_PAYLATER_OTP,
        searchParams: { payLaterCode: params.payLaterCode },
        bodyParams: {
            otp: params.otp,
            ...params.state,
        },
        options: {
            method: "POST",
        },
    });
}

export async function resendPayLaterOtp(apiHost: string, payLaterCode: string): Promise<object> {
    const response = unwrapResponse(
        await makeApiCall<object>({
            apiHost,
            endpoint: ENDPOINT.RESEND_PAYLATER_OTP,
            searchParams: { payLaterCode },
            options: {
                method: "POST",
            },
        }),
    );

    return response.toPromise();
}

export async function checkPayLaterLinkStatus(
    apiHost: string,
    payLaterCode: string,
    amount?: string,
): Promise<PayLaterLinkedData> {
    const response = unwrapResponse(
        await makeApiCall<PayLaterLinkedData>({
            apiHost,
            endpoint: ENDPOINT.CHECK_PAYLATER_LINK_STATUS,
            searchParams: { payLaterCode, amount: amount || "" },
            options: {},
        }),
    );

    return response.unwrapOrElse(() => ({
        linked: false,
    }));
}
